const defaults = {
  single: true
};

const getThreshold = (type) => {
  switch (type) {
  case 'survey':
    return 0.05;
  case 'competition':
    return 0.05;
  case 'toplist':
    return 0.01;
  default:
    return 0.3;
  }
};


const enterViewport = (type, el, handler, options = {}) => {
  if (!window.IntersectionObserver) return;

  // console.log('enterViewport', type, el)

  const settings = { ...defaults, ...options };
  let observer;

  const callback = (entries) => entries.forEach( (entry = {}) => {
    if (entry.isIntersecting) {
      console.log('Intersecting');
      // execute the custom handler.
      if (typeof handler === 'function') handler();

      // unobserve if its a single use only.
      if (settings.single) observer.unobserve(entry.target);
    }
  });

  const threshold = getThreshold(type);
  console.log(`threshold for intersectionObserver for ${ type }`, threshold);

  observer = new IntersectionObserver(callback, { threshold });
  observer.observe(el);
};

export default enterViewport;
